const LEGACY_SW_CLEARED_KEY = "invoice_sw_legacy_cleared";

function scriptUrl(reg: ServiceWorkerRegistration): string {
  return (
    reg.active?.scriptURL ||
    reg.waiting?.scriptURL ||
    reg.installing?.scriptURL ||
    ""
  ).toLowerCase();
}

function isLegacyServiceWorker(reg: ServiceWorkerRegistration): boolean {
  const url = scriptUrl(reg);
  // Old Next/Workbox bundles shipped as /sw.js or workbox-*.js (not vite-plugin-pwa dev-sw).
  if (url.includes("workbox")) {
    return true;
  }
  if (url.endsWith("/sw.js") && !url.includes("dev-sw")) {
    return true;
  }

  return false;
}

/** Unregister stale Next-era SW; returns true if caller should reload once. */
export async function cleanupLegacyServiceWorkers(): Promise<boolean> {
  if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) {
    return false;
  }
  if (sessionStorage.getItem(LEGACY_SW_CLEARED_KEY) === "1") {
    return false;
  }

  const regs = await navigator.serviceWorker.getRegistrations();
  const stale = regs.filter(isLegacyServiceWorker);
  if (stale.length === 0) {
    return false;
  }

  sessionStorage.setItem(LEGACY_SW_CLEARED_KEY, "1");
  await Promise.all(stale.map((r) => r.unregister()));

  return true;
}

export async function registerAppServiceWorker(): Promise<void> {
  if (import.meta.env.DEV) {
    return;
  }
  const { registerSW } = await import("virtual:pwa-register");
  registerSW({ immediate: true });
}
